module.exports = __webpack_public_path__ + "img/dauphinssurlelac.3d0b763f.jpg";